import React from 'react';
import { flowRight as compose } from 'lodash';
import gql from 'graphql-tag';

import s from './StartScreen.module.scss';
import withAuthentication, {
  LOGGED_MODE_USER,
} from '../Auth/AuthenticationWrapper';
import Loading from '../Loading';
import { withRouter } from '../../util/withRouter';
import { setGuestLocalStorageData } from '../Auth/withLogin';
import {
  TEST_MODE_PILOT,
  TEST_MODE_VERIFICATION,
} from '../../constants/testModes';
import { withSEO } from '../SEO/withSEO';
import StartSlide from './StartSlide';
import JobsSlide from './JobsSlide';
import DownloadSlide from './DownloadSlide';

export const createItestDataMutation = gql`
  mutation createUserItestData($itestMode: String!, $override: Boolean!) {
    createUserItestData(itestMode: $itestMode, override: $override)
  }
`;

interface StartScreenProps {
  location: Location;
  loggedMode: string;
}

class StartScreen extends React.Component<StartScreenProps> {
  // eslint-disable-next-line react/state-in-constructor
  state: any;

  constructor(props: any) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    const { location, loggedMode } = this.props;

    const isPilot = location.pathname.includes('normalization');
    const isVerification = location.pathname.includes('verification');

    sessionStorage.removeItem('normalization_data');

    if (isPilot || isVerification) {
      sessionStorage.removeItem('id_token');
      sessionStorage.removeItem('guest_data');

      const newGuestData: any = {
        userItestMode: isPilot ? TEST_MODE_PILOT : TEST_MODE_VERIFICATION,
      };
      setGuestLocalStorageData(newGuestData);

      // if logged mode is still cahced as user, need to reload page
      if (loggedMode === LOGGED_MODE_USER) {
        window.location.reload();
      }
    }
  }

  render() {
    return (
      <div className={s.startScreenContainer} data-nosnippet>
        <StartSlide />
        <JobsSlide />
        <DownloadSlide />
        {this.state.loading && <Loading key="loading" />}
      </div>
    );
  }
}

export default compose(
  withSEO({
    title: 'Welcher Beruf passt zu mir? Finde es heraus mit Jopsy!',
    description:
      'Jopsy ist ein wissenschaftlich fundierter, bildbasierter Berufsinteressenstest. Finde heraus, welcher Job zu dir passt. Starte gleich den Test!',
  }),
  withAuthentication,
  withRouter,
)(StartScreen);
